<template>
  <div id="IntroductionRequest">
    <section>
      <div id="container-center">
        <form>
          <h1 style="" class="title has-text-centered">{{title}}</h1>
          <div id="item-contens">
            <div class="card-content margin-top">
              <span style="font-size: 20px">紹介内容</span>
              <table>
                <tr>
                  <th>紹介先医療機関名<span class="require"/></th>
                  <td>
                    <input type="text" style="width:730px;" name="紹介先医療機関名" v-model="hospitalName" validate="required" disabled />
                    <b-button style="margin-left:10px; width:150px; height:27px;" @click="organizationModalActive=true">医療機関選択</b-button>
                  </td>
                </tr>
                <tr>
                  <th>患者名<span class="require"/></th>
                  <td>
                    <input type="text" name="患者名" v-model="patientName" validate="required" maxlength="256"/>
                  </td>
                </tr>
                <tr>
                  <th>紹介者名<span class="require"/></th>
                  <td>
                    <input type="text" name="紹介者名" v-model="introducer" validate="required" maxlength="256"/>
                  </td>
                </tr>
                <tr>
                  <th>紹介元医療機関名<span class="require"/></th>
                  <td>
                    <input type="text" name="紹介元医療機関名" v-model="introducersHospital" validate="required" maxlength="256"/>
                  </td>
                </tr>
                <tr>
                  <th>紹介文<span class="require"/></th>
                  <td>
                    <textarea style="height:250px" name="紹介文" validate="required" v-model="message" maxlength="256"/>
                  </td>
                </tr>
                <tr><th>検査結果</th><td><b-checkbox class="cstmCheckBox" v-model="shareResult">検査結果を共有する</b-checkbox></td></tr>   
              </table>
            </div>
            <div class="button-area">
              <b-button class="is-primary" style="margin-top:5px;width:250px;" icon-left="send" @click="request">メール送信</b-button>
              <b-button class="backButton is-primary" @click="back">戻る</b-button>
            </div>
          </div>
        </form>
      </div>
    </section>
    <b-modal :active.sync="organizationModalActive" has-modal-card>
      <organizationSelectModal :serviceId="serviceId" :title="selectModalTitle" :exclusionId="userBelongsId" :displayMail="false" :agreedInfoDisclosure="true" :cpapDepositUseFlg="false" @select="setOrganization"></organizationSelectModal>
    </b-modal>
  </div>
</template>
<script>
import {role} from "@/components/mock/base/const.js";
import {choicesType} from "@/components/mock/base/const.js";
import {extUserStatus} from "@/components/mock/base/const.js";
import {service} from "@/components/mock/base/const.js";
import {introductionTemplate} from "@/components/mock/base/const.js";
import OrganizationSelectModal from "@/components/mock/guest/OrganizationSelectModal";
export default {
  name: "IntroductionRequest",
  methods: {
    request: function() {
      // バリデーションチェック
      const elements = document.querySelectorAll('#item-contens [validate]');
      const result = this.selfMadeValidation(elements);
      if (result.isError) {
        this.showErrorMessage(result.msg);
        return; // エラーの場合はメール送信を中止
      }

      var messsage = this.title + "メールを送信します。"
      this.$dialog.confirm({
        title: "確認",
        message: messsage,
        cancelText: "キャンセル",
        onConfirm: async () => {
          var excuteApi = this.sendIntroductionMailPOST;
          var successCallBack = this.sendIntroductionMailPOSTSuccess;
          var errorCallBack = this.sendIntroductionMailPOSTError;
          // WebAPI Call
          await this.apiCall(excuteApi, successCallBack, errorCallBack)
        }
      });
    },
    sendIntroductionMailPOST: function(client) {
      let _this = this;
      return client.apis.externalRequestSearch.sendIntroductionMailPOST({
        body:{
          receiptNumber:_this.preReceiptNumber,
          kind: _this.preKind,
          belongsId:_this.belongsId,
          hospitalName:_this.hospitalName,
          introducer:_this.introducer,
          introducersHospital:_this.introducersHospital,
          patientName:_this.patientName,
          message:_this.message,
          shareResult:_this.shareResult,
          serviceId: _this.serviceId + ""
        }
      });
    },
    sendIntroductionMailPOSTSuccess: function(result) {
      // メッセージ表示
      this.showSuccess(result);
      this.$router.push({
        name: "RequestFormList",
        params: { searchConditions: this.searchParams },
      });
    },
    sendIntroductionMailPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    back: function() {
      // this.$router.go(-1);
      this.$router.push({
        name: "RequestFormList",
        params: { searchConditions: this.searchParams },
      });
    },
    setOrganization: function(organizationInfo){
      this.belongsId = organizationInfo.id
      this.hospitalName = organizationInfo.orgName;
    },
  },
  data() {
    var searchParams = this.$route.params["searchConditions"];
    var kind = this.$route.params["kind"];
    var prekind = this.$route.params["prekind"];
    var preReceiptNumber = this.$route.params["receiptNumber"];
    var preData = this.$route.params["item"];
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    var roleId = userInfo.roleId;
    var userId = userInfo.id;
    var userBelongsId = userInfo.belongsId;
    var title = "施設紹介"
    var serviceId = 0
    var selectModalTitle
    if (kind=='hst') {
      title = "睡眠宅配検査" + title;
      selectModalTitle = "睡眠宅配検査利用施設一覧"
      serviceId = service.hst;
    } else if (kind=='psg') {
      selectModalTitle = "PSG解析利用施設一覧"
      title = "PSG解析" + title;
      serviceId = service.psg;
    } else if (kind=='cpap') {
      title = "CPAP治療" + title;
      selectModalTitle = "CPAP利用施設一覧"
      serviceId = service.cpap;
    } else if (kind === 'holter') {
      title = 'ホルター心電図' + title
      selectModalTitle = 'ホルター心電図検査実施施設一覧'
      serviceId = service.holter
    }
    
    var patientsData = preData.patientsData
    var patientName = patientsData ?  patientsData[0].patientFamilyName + " " + patientsData[0].patientFirstName : preData.patientFamilyName + " " + preData.patientFirstName
    return {
      role: role,
      roleId: roleId,
      userId: userId,
      userBelongsId: userBelongsId,
      choicesType:choicesType,
      extUserStatus: extUserStatus,
      searchParams,
      title,
      selectModalTitle,
      serviceId,
      organizationModalActive: false,
      preReceiptNumber,
      preKind: prekind,
      belongsId: "",
      hospitalName: "",
      patientName,
      introducersHospital: userInfo.medicalInstitutionName + " " + userInfo.departmentName,
      introducer: userInfo.lastName + " " + userInfo.firstName,
      message: introductionTemplate[kind],
      shareResult: false,
    };
  },
  computed: {},
  components: {
    organizationSelectModal:OrganizationSelectModal,
  },
  async mounted() {
  }
};
</script>

<style>
</style>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/mock/guest/introduction/IntroductionRequest.vue